export const printDoc = () => {
  let inFrame = false;
  try {
    inFrame = window.self !== window.top;
  } catch (e) {
    inFrame = true;
  }
  if (!inFrame) {
    try {
      if (window.print) window.print();
    } catch (e) {}
    return;
  }
  try {
    const sheet = document.querySelector('.a4-sheet, .doc-sheet');
    if (!sheet) {
      try {
        if (window.print) window.print();
      } catch (e) {}
      return;
    }
    if (document.getElementById('a4-view-ov')) return;
    const ov = document.createElement('div');
    ov.id = 'a4-view-ov';
    ov.style.cssText =
      'position:fixed;inset:0;z-index:99999;background:#3a3f47;overflow:auto;-webkit-overflow-scrolling:touch;padding:52px 8px 20px;';
    const clone = sheet.cloneNode(true);
    clone.style.margin = '0 auto';
    clone.style.boxShadow = '0 6px 26px rgba(0,0,0,.45)';
    clone.style.maxWidth = '210mm';
    clone.style.width = '100%';
    clone.style.minHeight = 'auto';
    const bar = document.createElement('div');
    bar.style.cssText =
      'position:fixed;top:0;left:0;right:0;height:44px;background:#0F1A2E;display:flex;align-items:center;justify-content:space-between;padding:0 12px;z-index:100000;box-shadow:0 2px 8px rgba(0,0,0,.3)';
    bar.innerHTML =
      '<span style="color:#fff;font-size:12px;font-weight:800;font-family:system-ui,sans-serif">\uD83D\uDCC4 Aper\u00e7u A4 du document</span>';
    const close = document.createElement('button');
    close.textContent = '\u2715 Fermer';
    close.style.cssText =
      'background:rgba(255,255,255,.22);border:none;color:#fff;border-radius:8px;padding:8px 13px;font-size:12px;font-weight:800;cursor:pointer;font-family:system-ui,sans-serif';
    close.onclick = function () {
      try {
        ov.remove();
      } catch (e) {}
    };
    bar.appendChild(close);
    const note = document.createElement('div');
    note.style.cssText =
      'text-align:center;color:rgba(255,255,255,.8);font-size:10px;margin-top:14px;font-family:system-ui,sans-serif;line-height:1.55;padding:0 18px 10px';
    note.innerHTML =
      'Voici votre document en A4, tel qu\u2019il sera imprim\u00e9.<br>Pour l\u2019enregistrer\u00a0: faites une <b>capture d\u2019\u00e9cran</b>, ou ouvrez l\u2019app dans <b>Safari</b> (une fois en ligne) puis touchez PDF.';
    ov.appendChild(clone);
    ov.appendChild(note);
    ov.appendChild(bar);
    document.body.appendChild(ov);
  } catch (e) {
    try {
      if (window.print) window.print();
    } catch (e2) {}
  }
};
